import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Table } from 'primeng/table';
import { from, Observable, Subject } from 'rxjs';
import { distinct, distinctUntilChanged, groupBy, map, mergeMap, takeUntil, toArray } from 'rxjs/operators';
import { VCustomerTerminalMain } from 'src/app/models/entities/v-customer-terminal-main';
import { CustomerTerminalMainService } from 'src/app/services/customer-terminal-main.service';

@Component({
  selector: 'app-general-report',
  templateUrl: './general-report.component.html',
  styleUrls: ['./general-report.component.css']
})
export class GeneralReportComponent implements OnInit {

  bindData: VCustomerTerminalMain[] = [];
  filteredData: VCustomerTerminalMain[] = [];
  customers: VCustomerTerminalMain[] = [];
  dealers: VCustomerTerminalMain[] = [];
  projects: VCustomerTerminalMain[] = [];
  portals: VCustomerTerminalMain[] = [];
  services: VCustomerTerminalMain[] = [];
  exportDatas: any[] = [];
  destroy$ = new Subject<void>();

  @ViewChild('dt', { static: false }) dt: Table;

  constructor(
    private customerTerminalMainService: CustomerTerminalMainService
  ) { }

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.customerTerminalMainService.getReport().pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.bindData = res.data;
      from(this.bindData).pipe(distinct(d => d.customerName), takeUntil(this.destroy$)).subscribe(val => this.customers.push(val));
      from(this.bindData).pipe(distinct(d => d.dealerName), takeUntil(this.destroy$)).subscribe(val => this.dealers.push(val));
      from(this.bindData).pipe(distinct(d => d.projectName), takeUntil(this.destroy$)).subscribe(val => this.projects.push(val));
      from(this.bindData).pipe(distinct(d => d.portalName), takeUntil(this.destroy$)).subscribe(val => this.portals.push(val));
      from(this.bindData).pipe(distinct(d => d.serviceName), takeUntil(this.destroy$)).subscribe(val => this.services.push(val));
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.exportDatas);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "Müşteri-Terminal Raporu");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + ' ' + formatDate(new Date, 'dd-MM-yyyy', 'en') + EXCEL_EXTENSION);
  }


  calcTerminals() {
    let total = 0;
    for (let data of this.filteredData) {
      total += data.numberOfTerminals;
    }
    return total;
  }

  filterData($event: Table) {
    this.exportDatas = [];
    this.filteredData = $event.filteredValue;
    for (let index = 0; index < this.filteredData.length; index++) {
      const element = this.filteredData[index];
      this.exportDatas.push(
        {
          "Müşteri": element.customerName,
          "Bayi": element.dealerName,
          "Proje": element.projectName,
          "Portal": element.portalName,
          "Hizmet": element.serviceName,
          "Hizmet Bedeli": element.serviceUnitPrice,
          "Komisyon Bedeli": element.commissionPrice,
          "Para Birimi": element.currencyUnit,
          "Adet": element.numberOfTerminals
        }
      )
    }
    this.exportDatas.push(
      {
        "Müşteri": "",
        "Bayi": "",
        "Proje": "",
        "Portal": "",
        "Hizmet": "",
        "Hizmet Bedeli": "",
        "Komisyon Bedeli": "",
        "Para Birimi": "",
        "Adet": "Toplam Adet: " + this.calcTerminals()
      }
    )
  }

}
